// Copyright 2026. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';
import { COLORS } from 'admin/core/theme';

export const CardHeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
    width: 100%;

    margin-bottom: 16px;

    a {
        color: ${COLORS.PRIMARY};
        flex-shrink: 0;
    }
`;

export const CardHeaderText = styled.div`
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
`;
